import {CSAT_RANGE} from './csat-range.model';

/** Ordre d'affichage des étendues dans le paramétrage : de la plus courte à la plus longue. */
export const CSAT_RANGES: CSAT_RANGE[] = [CSAT_RANGE.ONE_TO_FOUR, CSAT_RANGE.ONE_TO_FIVE, CSAT_RANGE.ZERO_TO_TEN];
